import { useEffect } from "react";
import { Navigate } from "react-router-dom";
import { clearClientSession } from "utils/clientSession";

export default function ClientLogout() {
  useEffect(() => {
    clearClientSession();
  }, []);

  return <Navigate to="/login" replace />;
}
